import { gql } from "@apollo/client";

export const getMemberProfileQuery = gql`
  query GetMyMemberProfile {
    getMyMemberProfile {
      id
      first_name
      last_name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      profile
      authId
      dateOfJoining
    }
  }
`;

export const updateHostProfileMutation = gql`
  mutation UpdateMyMemberProfile($data: UpdateMemberInput!) {
    updateMyMemberProfile(data: $data) {
      id
      first_name
      last_name
      location_address
      phone_number
      website
      authId
    }
  }
`;
